export type Lang = "es" | "en";

const dict: Record<Lang, Record<string, string>> = {
  es: {
    "sidebar.home": "Inicio",
    "sidebar.runs": "Ejecuciones",
    "sidebar.scenarios": "Escenarios",
    "sidebar.compare": "Comparar",
    "sidebar.nodal": "Nodal",
    "sidebar.signOut": "Salir",
    "sidebar.theme": "Tema",

    "login.welcome": "Bienvenido",
    "login.subtitle": "Inicia sesion en tu cuenta de GridForge",
    "login.email": "Email",
    "login.password": "Contrasena",
    "login.forgotPassword": "Olvidaste tu contrasena?",
    "login.signIn": "Entrar",
    "login.noAccount": "No tienes cuenta?",
    "login.createAccount": "Crear cuenta",
    "login.enterEmailFirst": "Ingresa tu correo primero.",
    "login.checkEmail": "Revisa tu correo para restablecer tu contrasena.",

    "signup.title": "Crear cuenta",
    "signup.subtitle": "Crea tu cuenta en GridForge",
    "signup.email": "Email",
    "signup.password": "Contrasena",
    "signup.confirmPassword": "Confirmar contrasena",
    "signup.createAccount": "Crear cuenta",
    "signup.hasAccount": "Ya tienes cuenta?",
    "signup.signIn": "Iniciar sesion",
    "signup.passwordsDontMatch": "Las contrasenas no coinciden.",

    "resetPassword.title": "Restablecer contrasena",
    "resetPassword.subtitle": "Ingresa tu nueva contrasena",
    "resetPassword.newPassword": "Nueva contrasena",
    "resetPassword.confirmPassword": "Confirmar contrasena",
    "resetPassword.save": "Guardar contrasena",
    "resetPassword.passwordsDontMatch": "Las contrasenas no coinciden.",

    "runs.title": "Ejecuciones",
    "runs.subtitle": "Historial de modelado de despacho",
    "runs.stats.total": "Total",
    "runs.stats.pending": "Pendientes",
    "runs.stats.running": "En ejecucion",
    "runs.stats.done": "Completadas",
    "runs.stats.failed": "Fallidas",
    "runs.newExecution": "Nueva ejecucion",
    "runs.newExecutionDesc": "Configura e inicia una ejecucion de despacho para una fecha especifica.",
    "runs.executionHistory": "Historial de ejecuciones",
    "runs.loading": "Cargando ejecuciones...",
    "runs.loadError": "No se pudieron cargar las ejecuciones.",
    "runs.empty": "Sin ejecuciones todavia.",
    "runs.emptyHint": "Crea tu primera ejecucion usando el formulario de arriba.",

    "home.title": "Precios del mercado",
    "home.subtitle": "Bolsa real, MPO de XM y simulaciones del modelo por dia",
    "home.tx1": "Bolsa real (TX1)",
    "home.mpo": "MPO XM (iMAR)",
    "home.idealSettled": "Ideal liquidado",
    "home.idealProv": "Ideal provisional",
    "home.preideal": "Preideal",
    "home.loading": "Cargando serie...",
    "home.empty": "Sin datos de serie todavia.",
    "home.error": "No se pudo cargar la serie.",
    "home.retry": "Reintentar",
    "home.tx1Lag": "TX1 publica con 2-4 dias de retraso.",
    "home.hourly": "Detalle horario",
    "home.hourlyEmpty": "Sin detalle horario para este dia.",
    "home.viewRun": "Ver run",
    "home.close": "Cerrar",

    "runDetail.loading": "Cargando detalles...",
    "runDetail.dispatchChart": "Despacho por generador",
    "runDetail.nodalCtaTitle": "Esta es una corrida nodal (LMP)",
    "runDetail.nodalCtaBody": "Precios por zona, despacho por planta, flujos de rama y descargas viven en el analisis nodal.",
    "runDetail.downloadResults": "Descargar resultados",
    "runDetail.solverLog": "Log del solver",
    "runDetail.rmse": "RMSE",
    "runDetail.mae": "MAE",
    "runDetail.bias": "Sesgo",
    "runDetail.r2": "R²",
    "runDetail.wape": "WAPE",
    "runDetail.smape": "sMAPE",
    "runDetail.dispatchMae": "MAE despacho",
    "runDetail.dispatchRms": "RMSE despacho",
    "runDetail.copMwh": "COP/MWh",
    "runDetail.pricesChart": "Precios",
    "runDetail.marginalPlants": "Plantas que marginan",
    "runDetail.modelMpo": "Modelo MPO",
    "runDetail.xmMpo": "XM MPO",
    "runDetail.bessCharge": "Carga BESS",
    "runDetail.bessDischarge": "Descarga BESS",
    "runDetail.netRevenue": "Ingreso neto",

    "createRun.date": "Fecha",
    "createRun.dateHelp": "Fecha de despacho (YYYY-MM-DD)",
    "createRun.level": "Nivel",
    "createRun.levelHelp": "Nivel de pronostico de demanda",
    "createRun.solver": "Solver",
    "createRun.solverHelp": "Motor de optimizacion",
    "createRun.scenario": "Escenario BESS",
    "createRun.scenarioHelp": "Penetracion y modo BESS (opcional)",
    "createRun.none": "Ninguno",
    "createRun.submit": "Crear ejecucion",
    "createRun.creating": "Creando...",
    "createRun.comingSoon": "proximamente",
    "createRun.nodalNetwork": "Red nodal",
    "createRun.nodalNetworkHelp": "Red de transmision para analisis nodal (requerida para nivel lmp)",
    "createRun.nodalNetworkRequired": "Seleccione o cargue una red nodal",
    "createRun.recomputeDemandShares": "Calcular demand-share por fecha",
    "createRun.recomputeDemandSharesTooltip": "Recalcula la proporcion de demanda por zona usando la demanda real de la fecha de despacho (dDEM historico o pronostico PRON), en vez del promedio guardado al momento del scrape. Agrega tiempo a la creacion de la corrida porque descarga el archivo de demanda de esa fecha.",

    "nodalNetwork.example": "Cargar red de ejemplo",
    "nodalNetwork.loadColombia": "Cargar red colombiana",
    "nodalNetwork.loading": "Cargando...",
    "nodalNetwork.scrapeColombia": "Actualizar red colombiana",
    "nodalNetwork.scraping": "Actualizando...",
    "nodalNetwork.valid": "Red valida",
    "nodalNetwork.invalid": "Red invalida",
    "nodalNetwork.jsonPlaceholder": "Pegue aqui el JSON de la red nodal",
    "nodalNetwork.errors": "Errores de validacion",
    "nodalNetwork.error.jsonInvalid": "JSON invalido",
    "nodalNetwork.error.zonesRequired": "Zonas debe ser un array no vacio de objetos con nombre",
    "nodalNetwork.error.referenceZoneInvalid": "La zona de referencia no existe en zonas",
    "nodalNetwork.error.generatorInvalid": "Generador invalido: nombre, zona, p_max y costo marginal requeridos y zona existente",
    "nodalNetwork.error.branchInvalid": "Rama invalida: nombre, zonas de origen y destino existentes, reactancia y capacidad requeridas",
    "nodalNetwork.error.loadInvalid": "Carga invalida: zona existente y p_load con exactamente 24 numeros",
    "nodalNetwork.error.demandSharesInvalid": "demand_shares debe cubrir exactamente las zonas de la red y sumar 1.0",

    "nodalNetwork.graph.viewGraph": "Ver grafo",
    "nodalNetwork.graph.dialogTitle": "Grafo de la red",
    "nodalNetwork.graph.close": "Cerrar",
    "nodalNetwork.graph.referenceZone": "Zona de referencia",
    "nodalNetwork.graph.installedCapacity": "Capacidad instalada (MW)",
    "nodalNetwork.graph.peakDemand": "Demanda pico (MW)",
    "nodalNetwork.graph.generators": "Generadores",
    "nodalNetwork.graph.branches": "Ramas conectadas",
    "nodalNetwork.graph.reactance": "Reactancia",
    "nodalNetwork.graph.rating": "Capacidad (MW)",
    "nodalNetwork.graph.fuel": "Combustible",
    "nodalNetwork.graph.marginalCost": "Costo marginal",
    "nodalNetwork.graph.pMax": "Pmax (MW)",
    "nodalNetwork.graph.noGenerators": "Sin generadores en esta zona",
    "nodalNetwork.graph.noBranches": "Sin ramas conectadas a esta zona",
    "nodalNetwork.graph.zoneDetails": "Detalle de zona",
    "nodalNetwork.graph.expandZone": "Ampliar zona",

    "runsTable.date": "Fecha",
    "runsTable.level": "Nivel",
    "runsTable.status": "Estado",
    "runsTable.created": "Creado",
    "runsTable.duration": "Duracion",
    "runsTable.view": "Ver",
    "runsTable.runId": "ID de corrida",
    "runsTable.empty": "Sin ejecuciones todavia.",

    "status.pending": "Pendiente",
    "status.running": "En ejecucion",
    "status.done": "Completado",
    "status.failed": "Fallido",

    "scenarios.title": "Escenarios BESS",
    "scenarios.subtitle": "Configura escenarios de almacenamiento de energia para la simulacion de despacho",
    "scenarios.create": "Crear escenario",
    "scenarios.saved": "Escenarios guardados",
    "scenarios.loading": "Cargando escenarios...",
    "scenarios.empty": "Sin escenarios todavia. Crea uno arriba para empezar.",

    "createScenario.mode": "Modo",
    "createScenario.penetrationLevel": "Nivel de penetracion",
    "createScenario.units": "Unidades BESS",
    "createScenario.unit": "Unidad",
    "createScenario.name": "Nombre",
    "createScenario.capacity": "Capacidad (MWh)",
    "createScenario.hoursToDeplete": "Horas para agotar",
    "createScenario.initialSoc": "SOC inicial (0-1)",
    "createScenario.minSoc": "SOC minimo (0-1)",
    "createScenario.maxSoc": "SOC maximo (0-1)",
    "createScenario.efficiency": "Eficiencia (0-1)",
    "createScenario.chargeBid": "Oferta de carga",
    "createScenario.dischargeBid": "Oferta de descarga",
    "createScenario.addUnit": "Agregar unidad",
    "createScenario.removeUnit": "Quitar unidad",
    "createScenario.submit": "Crear escenario",

    "scenariosTable.penetration": "Nivel de penetracion",
    "scenariosTable.mode": "Modo",
    "scenariosTable.units": "Unidades",
    "scenariosTable.created": "Creado",
    "scenariosTable.empty": "Sin escenarios todavia.",

    "compare.title": "Comparar ejecuciones",
    "compare.subtitle": "Compara metricas entre ejecuciones de despacho completadas",
    "compare.selectRuns": "Seleccionar ejecuciones",
    "compare.metricsComparison": "Comparacion de metricas",
    "compare.noCompleted": "No hay ejecuciones completas para comparar.",
    "compare.selectHint": "Select up to 5 completed runs to compare",
    "compare.loading": "Cargando ejecuciones...",
    "compare.loadError": "No se pudo cargar alguna ejecucion.",
    "compare.metric": "Metrica",
    "compare.noMetrics": "sin metricas",

    "chart.noData": "No hay datos de despacho todavia.",
    "chart.pricesNoData": "No hay datos de precios todavia.",
    "chart.hour": "Hora del dia",
    "chart.hourLabel": "Hora",
    "chart.mw": "MW",
    "chart.others": "Otros",
    "chart.resetZoom": "Restablecer zoom",
    "chart.zoomHint": "Rueda: zoom · Arrastrar: desplazar · Doble clic: restablecer",

    "artifacts.noData": "No hay artefactos disponibles todavia.",
    "artifacts.downloadError": "No se pudo descargar el artefacto.",
    "artifacts.dispatch": "Despacho CSV",
    "artifacts.prices": "Precios CSV",
    "artifacts.bess": "BESS CSV",
    "artifacts.marginalPlants": "Plantas marginales CSV",
    "artifacts.priceComparison": "Comparacion de precios CSV",

    "marginalPlants.empty": "Sin plantas que marginan.",
    "marginalPlants.generator": "Generador",
    "marginalPlants.dispatch": "Despacho (MW)",
    "marginalPlants.pmax": "Pmax (MW)",
    "marginalPlants.hour": "Hora",

    "nodal.listTitle": "Corridas nodales",
    "nodal.listSubtitle": "Corridas de despacho LMP con comparacion de precios",
    "nodal.noRuns": "No hay corridas nodales aun",
    "nodal.noRunsHint": "Crea una corrida con nivel LMP desde la pagina de ejecuciones",
    "nodal.openDashboard": "Analisis nodal",
    "nodal.backToRun": "Volver al detalle",
    "nodal.hour": "Hora",
    "nodal.totalCost": "Costo total",
    "nodal.loadPaymentDelta": "Delta pago demanda",
    "nodal.genRevenueDelta": "Delta ingreso generacion",
    "nodal.congestionRent": "Renta de congestion",
    "nodal.priceAvg": "Precio promedio",
    "nodal.priceVol": "Volatilidad",
    "nodal.unitMw": "MW",
    "nodal.mapTitle": "Mapa zonal",
    "nodal.mapSubtitle": "LMP por zona en la hora seleccionada",
    "nodal.networkTitle": "Red utilizada",
    "nodal.networkName": "Nombre",
    "nodal.baseMva": "Base MVA",
    "nodal.referenceZone": "Zona de referencia",
    "nodal.zone": "Zona",
    "nodal.generator": "Generador",
    "nodal.fuel": "Combustible",
    "nodal.marginalCost": "Costo marginal",
    "nodal.branch": "Rama",
    "nodal.zones": "Zonas",
    "nodal.generators": "Generadores",
    "nodal.branches": "Ramas",
    "nodal.fromTo": "Tramo",
    "nodal.reactance": "Reactancia",
    "nodal.rating": "Capacidad (MW)",
    "nodal.load": "Carga",
    "nodal.installedCapacity": "Capacidad instalada",
    "nodal.priceCurvesTitle": "Curvas de precio",
    "nodal.priceCurvesSubtitle": "LMP por zona y precio promedio ponderado por demanda",
    "nodal.avgPrice": "Precio promedio ponderado",
    "nodal.avgPriceModelLabel": "Precio promedio ponderado",
    "nodal.bolsaRealLabel": "Bolsa real",
    "nodal.dispatchTitle": "Despacho nodal",
    "nodal.branchFlowsTitle": "Flujos de rama",
    "nodal.differentialTitle": "Tabla de diferencial",
    "nodal.loadPaymentA": "Pago demanda A",
    "nodal.loadPaymentB": "Pago demanda B",
    "nodal.delta": "Delta",
    "nodal.genRevenueA": "Ingreso generacion A",
    "nodal.genRevenueB": "Ingreso generacion B",
    "nodal.redistributionTitle": "Matriz de redistribucion",
    "nodal.redistributionSubtitle": "Cambio neto en pago de la demanda por zona (B - A)",
    "nodal.downloadsTitle": "Descargas",
    "nodal.noNodalData": "No hay datos nodales para esta corrida",
    "nodal.dispatchNoData": "No hay datos de despacho nodal",
    "nodal.branchFlowsNoData": "No hay datos de flujos de rama",
    "nodal.artifact.lmp": "LMP por zona CSV",
    "nodal.artifact.dispatch": "Despacho nodal CSV",
    "nodal.artifact.branch_flows": "Flujos de rama CSV",
    "nodal.artifact.settlement_status_quo": "Liquidacion A (status quo) CSV",
    "nodal.artifact.settlement_lmp": "Liquidacion B (LMP) CSV",
    "nodal.artifact.comparison": "Comparacion CSV",
    "nodal.artifact.summary": "Resumen JSON",
    "nodal.congestionCurvesTitle": "Congestion por zona",
    "nodal.congestionCurvesSubtitle": "LMP menos precio promedio ponderado, por zona y hora",
    "nodal.priceComparisonTitle": "Precio promedio ponderado vs. bolsa real",
    "nodal.priceComparisonSubtitle": "Precio promedio ponderado por demanda vs. precio de bolsa real (PrecBolsNaci)",

    "table.rowsPerPage": "Filas por pagina",
    "table.pageOf": "Pagina {page} de {total}",
    "table.prev": "Anterior",
    "table.next": "Siguiente",

    "log.loading": "Cargando log...",
    "log.empty": "Sin logs todavia.",

    "lang.es": "ES",
    "lang.en": "EN",
  },

  en: {
    "sidebar.home": "Home",
    "sidebar.runs": "Runs",
    "sidebar.scenarios": "Scenarios",
    "sidebar.compare": "Compare",
    "sidebar.nodal": "Nodal",
    "sidebar.signOut": "Sign Out",
    "sidebar.theme": "Theme",

    "login.welcome": "Welcome back",
    "login.subtitle": "Sign in to your GridForge account",
    "login.email": "Email",
    "login.password": "Password",
    "login.forgotPassword": "Forgot your password?",
    "login.signIn": "Sign In",
    "login.noAccount": "Don't have an account?",
    "login.createAccount": "Create account",
    "login.enterEmailFirst": "Enter your email first.",
    "login.checkEmail": "Check your email to reset your password.",

    "signup.title": "Create account",
    "signup.subtitle": "Create your GridForge account",
    "signup.email": "Email",
    "signup.password": "Password",
    "signup.confirmPassword": "Confirm password",
    "signup.createAccount": "Create account",
    "signup.hasAccount": "Already have an account?",
    "signup.signIn": "Sign in",
    "signup.passwordsDontMatch": "Passwords do not match.",

    "resetPassword.title": "Reset password",
    "resetPassword.subtitle": "Enter your new password",
    "resetPassword.newPassword": "New password",
    "resetPassword.confirmPassword": "Confirm password",
    "resetPassword.save": "Save password",
    "resetPassword.passwordsDontMatch": "Passwords do not match.",

    "runs.title": "Dispatch Runs",
    "runs.subtitle": "History of dispatch modeling executions",
    "runs.stats.total": "Total",
    "runs.stats.pending": "Pending",
    "runs.stats.running": "Running",
    "runs.stats.done": "Done",
    "runs.stats.failed": "Failed",
    "runs.newExecution": "New Execution",
    "runs.newExecutionDesc": "Configure and launch a dispatch model run for a specific date.",
    "runs.executionHistory": "Execution History",
    "runs.loading": "Loading executions...",
    "runs.loadError": "Could not load executions.",
    "runs.empty": "No executions yet.",
    "runs.emptyHint": "Create your first dispatch run using the form above.",

    "home.title": "Market prices",
    "home.subtitle": "Real bolsa, XM MPO and model simulations per day",
    "home.tx1": "Real bolsa (TX1)",
    "home.mpo": "XM MPO (iMAR)",
    "home.idealSettled": "Settled ideal",
    "home.idealProv": "Provisional ideal",
    "home.preideal": "Preideal",
    "home.loading": "Loading series...",
    "home.empty": "No series data yet.",
    "home.error": "Could not load the series.",
    "home.retry": "Retry",
    "home.tx1Lag": "TX1 publishes with a 2-4 day lag.",
    "home.hourly": "Hourly detail",
    "home.hourlyEmpty": "No hourly detail for this day.",
    "home.viewRun": "View run",
    "home.close": "Close",

    "runDetail.loading": "Loading run details...",
    "runDetail.dispatchChart": "Dispatch by Generator",
    "runDetail.nodalCtaTitle": "This is a nodal (LMP) run",
    "runDetail.nodalCtaBody": "Per-zone prices, per-plant dispatch, branch flows and downloads live in the nodal analysis.",
    "runDetail.downloadResults": "Download Results",
    "runDetail.solverLog": "Solver Log",
    "runDetail.rmse": "RMSE",
    "runDetail.mae": "MAE",
    "runDetail.bias": "Bias",
    "runDetail.r2": "R²",
    "runDetail.wape": "WAPE",
    "runDetail.smape": "sMAPE",
    "runDetail.dispatchMae": "Dispatch MAE",
    "runDetail.dispatchRms": "Dispatch RMSE",
    "runDetail.copMwh": "COP/MWh",
    "runDetail.pricesChart": "Prices",
    "runDetail.marginalPlants": "Marginal Plants",
    "runDetail.modelMpo": "Model MPO",
    "runDetail.xmMpo": "XM MPO",
    "runDetail.bessCharge": "BESS Charge",
    "runDetail.bessDischarge": "BESS Discharge",
    "runDetail.netRevenue": "Net Revenue",

    "createRun.date": "Date",
    "createRun.dateHelp": "Dispatch date (YYYY-MM-DD)",
    "createRun.level": "Level",
    "createRun.levelHelp": "Demand forecast level",
    "createRun.solver": "Solver",
    "createRun.solverHelp": "Optimization solver engine",
    "createRun.scenario": "BESS Scenario",
    "createRun.scenarioHelp": "BESS penetration and mode (optional)",
    "createRun.none": "None",
    "createRun.submit": "Create Execution",
    "createRun.creating": "Creating...",
    "createRun.comingSoon": "coming soon",
    "createRun.nodalNetwork": "Nodal network",
    "createRun.nodalNetworkHelp": "Transmission network for nodal analysis (required for lmp level)",
    "createRun.nodalNetworkRequired": "Select or load a nodal network",
    "createRun.recomputeDemandShares": "Compute demand share by date",
    "createRun.recomputeDemandSharesTooltip": "Recomputes the per-zone demand share using the actual demand for the dispatch date (historical dDEM or forecast PRON), instead of the average saved at scrape time. Adds time to run creation because it downloads that date's demand file.",

    "nodalNetwork.example": "Load example network",
    "nodalNetwork.loadColombia": "Load Colombian network",
    "nodalNetwork.loading": "Loading...",
    "nodalNetwork.scrapeColombia": "Refresh Colombian network",
    "nodalNetwork.scraping": "Refreshing...",
    "nodalNetwork.valid": "Valid network",
    "nodalNetwork.invalid": "Invalid network",
    "nodalNetwork.jsonPlaceholder": "Paste the nodal network JSON here",
    "nodalNetwork.errors": "Validation errors",
    "nodalNetwork.error.jsonInvalid": "Invalid JSON",
    "nodalNetwork.error.zonesRequired": "zones must be a non-empty array of objects with a name",
    "nodalNetwork.error.referenceZoneInvalid": "The reference zone does not exist in zones",
    "nodalNetwork.error.generatorInvalid": "Invalid generator: name, zone, p_max and marginal cost required and zone must exist",
    "nodalNetwork.error.branchInvalid": "Invalid branch: name, existing from/to zones, reactance and rating required",
    "nodalNetwork.error.loadInvalid": "Invalid load: existing zone and p_load with exactly 24 numbers",
    "nodalNetwork.error.demandSharesInvalid": "demand_shares must cover exactly the network zones and sum to 1.0",

    "nodalNetwork.graph.viewGraph": "View graph",
    "nodalNetwork.graph.dialogTitle": "Network graph",
    "nodalNetwork.graph.close": "Close",
    "nodalNetwork.graph.referenceZone": "Reference zone",
    "nodalNetwork.graph.installedCapacity": "Installed capacity (MW)",
    "nodalNetwork.graph.peakDemand": "Peak demand (MW)",
    "nodalNetwork.graph.generators": "Generators",
    "nodalNetwork.graph.branches": "Connected branches",
    "nodalNetwork.graph.reactance": "Reactance",
    "nodalNetwork.graph.rating": "Rating (MW)",
    "nodalNetwork.graph.fuel": "Fuel",
    "nodalNetwork.graph.marginalCost": "Marginal cost",
    "nodalNetwork.graph.pMax": "Pmax (MW)",
    "nodalNetwork.graph.noGenerators": "No generators in this zone",
    "nodalNetwork.graph.noBranches": "No branches connected to this zone",
    "nodalNetwork.graph.zoneDetails": "Zone details",
    "nodalNetwork.graph.expandZone": "Expand zone",

    "runsTable.date": "Date",
    "runsTable.level": "Level",
    "runsTable.status": "Status",
    "runsTable.created": "Created",
    "runsTable.duration": "Duration",
    "runsTable.view": "View",
    "runsTable.runId": "Run ID",
    "runsTable.empty": "No executions yet.",

    "status.pending": "Pending",
    "status.running": "Running",
    "status.done": "Done",
    "status.failed": "Failed",

    "scenarios.title": "BESS Scenarios",
    "scenarios.subtitle": "Configure battery energy storage scenarios for dispatch simulation",
    "scenarios.create": "Create Scenario",
    "scenarios.saved": "Saved Scenarios",
    "scenarios.loading": "Loading scenarios...",
    "scenarios.empty": "No scenarios found. Create one above to get started.",

    "createScenario.mode": "Mode",
    "createScenario.penetrationLevel": "Penetration Level",
    "createScenario.units": "BESS Units",
    "createScenario.unit": "Unit",
    "createScenario.name": "Name",
    "createScenario.capacity": "Capacity (MWh)",
    "createScenario.hoursToDeplete": "Hours to deplete",
    "createScenario.initialSoc": "Initial SOC (0-1)",
    "createScenario.minSoc": "Min SOC (0-1)",
    "createScenario.maxSoc": "Max SOC (0-1)",
    "createScenario.efficiency": "Efficiency (0-1)",
    "createScenario.chargeBid": "Charge bid",
    "createScenario.dischargeBid": "Discharge bid",
    "createScenario.addUnit": "Add unit",
    "createScenario.removeUnit": "Remove unit",
    "createScenario.submit": "Create Scenario",

    "scenariosTable.penetration": "Penetration Level",
    "scenariosTable.mode": "Mode",
    "scenariosTable.units": "Units",
    "scenariosTable.created": "Created",
    "scenariosTable.empty": "No scenarios yet.",

    "compare.title": "Run Comparison",
    "compare.subtitle": "Compare metrics across completed dispatch executions",
    "compare.selectRuns": "Select Runs to Compare",
    "compare.metricsComparison": "Metrics Comparison",
    "compare.noCompleted": "No completed runs available for comparison.",
    "compare.selectHint": "Select up to 5 completed runs to compare",
    "compare.loading": "Loading executions...",
    "compare.loadError": "Could not load some executions.",
    "compare.metric": "Metric",
    "compare.noMetrics": "no metrics",

    "chart.noData": "No dispatch data yet.",
    "chart.pricesNoData": "No price data yet.",
    "chart.hour": "Hour of day",
    "chart.hourLabel": "Hour",
    "chart.mw": "MW",
    "chart.others": "Others",
    "chart.resetZoom": "Reset zoom",
    "chart.zoomHint": "Scroll: zoom · Drag: pan · Double-click: reset",

    "artifacts.noData": "No artifacts available yet.",
    "artifacts.downloadError": "Could not download artifact.",
    "artifacts.dispatch": "Dispatch CSV",
    "artifacts.prices": "Prices CSV",
    "artifacts.bess": "BESS CSV",
    "artifacts.marginalPlants": "Marginal Plants CSV",
    "artifacts.priceComparison": "Price Comparison CSV",

    "marginalPlants.empty": "No marginal plants.",
    "marginalPlants.generator": "Generator",
    "marginalPlants.dispatch": "Dispatch (MW)",
    "marginalPlants.pmax": "Pmax (MW)",
    "marginalPlants.hour": "Hour",

    "nodal.listTitle": "Nodal runs",
    "nodal.listSubtitle": "LMP dispatch runs with price comparison",
    "nodal.noRuns": "No nodal runs yet",
    "nodal.noRunsHint": "Create an LMP-level run from the runs page",
    "nodal.openDashboard": "Nodal analysis",
    "nodal.backToRun": "Back to run detail",
    "nodal.hour": "Hour",
    "nodal.totalCost": "Total cost",
    "nodal.loadPaymentDelta": "Load payment delta",
    "nodal.genRevenueDelta": "Generation revenue delta",
    "nodal.congestionRent": "Congestion rent",
    "nodal.priceAvg": "Average price",
    "nodal.priceVol": "Volatility",
    "nodal.unitMw": "MW",
    "nodal.mapTitle": "Zonal map",
    "nodal.mapSubtitle": "LMP per zone at the selected hour",
    "nodal.networkTitle": "Network used",
    "nodal.networkName": "Name",
    "nodal.baseMva": "Base MVA",
    "nodal.referenceZone": "Reference zone",
    "nodal.zone": "Zone",
    "nodal.generator": "Generator",
    "nodal.fuel": "Fuel",
    "nodal.marginalCost": "Marginal cost",
    "nodal.branch": "Branch",
    "nodal.zones": "Zones",
    "nodal.generators": "Generators",
    "nodal.branches": "Branches",
    "nodal.fromTo": "Segment",
    "nodal.reactance": "Reactance",
    "nodal.rating": "Rating (MW)",
    "nodal.load": "Load",
    "nodal.installedCapacity": "Installed capacity",
    "nodal.priceCurvesTitle": "Price curves",
    "nodal.priceCurvesSubtitle": "LMP per zone and demand-weighted average price",
    "nodal.avgPrice": "Weighted average price",
    "nodal.avgPriceModelLabel": "Weighted average price",
    "nodal.bolsaRealLabel": "Real bolsa price",
    "nodal.dispatchTitle": "Nodal dispatch",
    "nodal.branchFlowsTitle": "Branch flows",
    "nodal.differentialTitle": "Differential table",
    "nodal.loadPaymentA": "Load payment A",
    "nodal.loadPaymentB": "Load payment B",
    "nodal.delta": "Delta",
    "nodal.genRevenueA": "Generation revenue A",
    "nodal.genRevenueB": "Generation revenue B",
    "nodal.redistributionTitle": "Redistribution matrix",
    "nodal.redistributionSubtitle": "Net change in load payment per zone (B - A)",
    "nodal.downloadsTitle": "Downloads",
    "nodal.noNodalData": "No nodal data for this run",
    "nodal.dispatchNoData": "No nodal dispatch data",
    "nodal.branchFlowsNoData": "No branch flow data",
    "nodal.artifact.lmp": "Zonal LMP CSV",
    "nodal.artifact.dispatch": "Nodal dispatch CSV",
    "nodal.artifact.branch_flows": "Branch flows CSV",
    "nodal.artifact.settlement_status_quo": "Settlement A (status quo) CSV",
    "nodal.artifact.settlement_lmp": "Settlement B (LMP) CSV",
    "nodal.artifact.comparison": "Comparison CSV",
    "nodal.artifact.summary": "Summary JSON",
    "nodal.congestionCurvesTitle": "Congestion per zone",
    "nodal.congestionCurvesSubtitle": "LMP minus the weighted average price, per zone and hour",
    "nodal.priceComparisonTitle": "Weighted average price vs. real bolsa price",
    "nodal.priceComparisonSubtitle": "Demand-weighted average price vs. the real bolsa price (PrecBolsNaci)",

    "table.rowsPerPage": "Rows per page",
    "table.pageOf": "Page {page} of {total}",
    "table.prev": "Previous",
    "table.next": "Next",

    "log.loading": "Loading log...",
    "log.empty": "No logs yet.",

    "lang.es": "ES",
    "lang.en": "EN",
  },
};

export function t(lang: Lang, key: string): string {
  return dict[lang]?.[key] ?? key;
}
